export class Company {

    public sessionValid: boolean = false;
    public errorCode: any;
    public errorMessage: string = '';
    public errorMessageData: any;
    public verificationResult: any;
    public appExpiry: any;
    public profileStrengthInfo: any;
    public companyName: string = '';
    public companyLogo: boolean = false;
    public companyId: number = 0;
    public logoLastModified: number = 0;
    public companyProfile: string = '';
    public companyProfileVideo: string = '';
    public radius: number = 0;
    public totalJobs: number = 0;
    public companyCode: string = '';
    public companyUrl: string = '';
    public dynamicHeaderContent: string = '';

}